import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
export default ({ session, allSessions, index }) => {
  return (
    <Col
      lg={12}
      md={12}
      sm={12}
      xs={12}
      style={{
        // borderBottom: allSessions.length - 1 !== index ? "1px solid #ced4da" : "",
        marginBottom: "35px",
        padding: "0",
      }}
    >
      <Row className="flex-center">
        <Col xs={12}>
          <div className="time-style-upcmg">
            <span>{session?.date}<span className="unary-or"> | </span>{session?.time}<span className="unary-or"> | </span>{session.status? session.status : "temp" } </span>
          </div>
        </Col>
        <Col
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="flex-end-center btn-session"
        >
          {/* <Button className="rate-style">{`23.00`}</Button>
                <Button className="accept">Accept</Button>
                <Button className="decline">Decline</Button> */}
        </Col>
      </Row>
      <Row className="flex-center">
        <Col xs={12}>
          <Link
            style={{ "text-decoration": "none" }}
            to={`/tutor-dashboard/lessonDetails`}
          >
            <div className="session-info" style={{marginBottom: "0"}} >
              <div>
                <h5 className="black-txt">{session.name ? session?.name?.substring(0, session.name.indexOf(" ")) : "Sir"}</h5>
                <p className="subject">{`${session?.subject} - £20/lesson`}</p>
              </div>
              <img src={session?.imageUrl
                        ? session?.imageUrl
                        : "https://firebasestorage.googleapis.com/v0/b/askademia-36826.appspot.com/o/no-img.png?alt=media&token=139f8f26-4fa9-4cdf-88d7-a27859180a12"
                        } 
                    alt={`${session?.name}`}
                    width="41px" height="41px" className="rounded-circle"></img>
            </div>
          </Link>
        </Col>
      </Row>
    </Col>
  );
};
